import { render, staticRenderFns } from "./SilverStarIndex.vue?vue&type=template&id=37aec178&scoped=true"
import script from "./SilverStarIndex.vue?vue&type=script&lang=js"
export * from "./SilverStarIndex.vue?vue&type=script&lang=js"
import style0 from "./SilverStarIndex.vue?vue&type=style&index=0&id=37aec178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aec178",
  null
  
)

export default component.exports